import { FC } from "react";

import UserRoleContainer from "@app/containers/userRole";

const AddUserRolePage: FC = () => <UserRoleContainer />;

export default AddUserRolePage;
